function sortMapByProperty (map, keyName, comparator) {
     return map.sort((a,b) => comparator(a.get(keyName), b.get(keyName)));
}

export { sortMapByProperty };
